@if (fieldComp && isFieldVisible()) {
  <div class="row" [formGroup]="form">
    <div class="col-sm">
      <div>
        @switch (fieldComp.controlType) {
          @case (fieldType.Textbox) {
            <mat-form-field>
              <mat-label>{{ fieldComp.label }}</mat-label>
              <input matInput class="form-control" [formControlName]="fieldComp.key" [id]="fieldComp.key"
                autocomplete="off"
                [matTooltip]="fieldComp.description" matTooltipPosition="right"/>
              @if (form.get(fieldComp.key)?.invalid && form.get(fieldComp.key)?.touched) {
                <mat-error>{{ fieldComp.validationMessage || 'Invalid value' }}</mat-error>
              }
            </mat-form-field>
          }
          @case (fieldType.LongText) {
            <mat-form-field class="long">
              <mat-label>{{ fieldComp.label }}</mat-label>
              <input matInput class="form-control" [formControlName]="fieldComp.key" [id]="fieldComp.key"
                autocomplete="off"
                [matTooltip]="fieldComp.description" matTooltipPosition="right"/>
            </mat-form-field>
          }
          @case (fieldType.Textarea) {
            <mat-form-field class="textarea">
              <mat-label>{{ fieldComp.label }}</mat-label>
              <textarea matInput class="form-control" [formControlName]="fieldComp.key" [id]="fieldComp.key" rows="5"
                autocomplete="off"
              [matTooltip]="fieldComp.description" matTooltipPosition="right"></textarea>
            </mat-form-field>
          }
          @case (fieldType.Number) {
            <mat-form-field class="number">
              <mat-label>{{ fieldComp.label }}</mat-label>
              <input matInput type="number" class="form-control" [formControlName]="fieldComp.key" [id]="fieldComp.key"
                autocomplete="off"
                [matTooltip]="fieldComp.description" matTooltipPosition="right"/>
            </mat-form-field>
          }
          @case (fieldType.Dropdown) {
            <mat-form-field>
              <mat-label>{{ fieldComp.label }}</mat-label>
              @if (!fieldComp.multiple) {
                <mat-select
                  [formControlName]="fieldComp.key||''"
                  [matTooltip]="fieldComp.description" matTooltipPosition="right">
                  <mat-option value=""></mat-option>
                  @for (opt of displayedOptions; track opt) {
                    <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                  }
                </mat-select>
              }
              @if (fieldComp.multiple) {
                <mat-select
                  [value]="getMultiSelectValue(fieldComp.key)"
                  (selectionChange)="onMultiSelectChange(fieldComp.key, $event.value)"
                  [multiple]="true"
                  [matTooltip]="fieldComp.description" matTooltipPosition="right">
                  @for (opt of displayedOptions; track opt) {
                    <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                  }
                </mat-select>
              }
            </mat-form-field>
          }
          @case (fieldType.Image) {
            <pub-image-editor [fieldComp]="fieldComp" (setImage)="setValue($event)"></pub-image-editor>
          }
          @case (fieldType.PlainJSON) {
            <div class="json-field">
              <pub-json-input
                [formControlName]="fieldComp.key"
                [hasError]="!!(form.get(fieldComp.key)?.invalid && form.get(fieldComp.key)?.touched)"
                [errorMessage]="form.get(fieldComp.key)?.errors?.['invalidJson']?.message || 'Invalid JSON format'"
                pubJsonValidator
                [label]="fieldComp.label"
                [tooltip]="fieldComp.description"
                >
              </pub-json-input>
            </div>
          }
          @case (fieldType.JSON) {
            <div>
              <button mat-raised-button color="primary"
                (click)="openColumnConfigDialog()">
                Edit Columns
              </button>
            </div>
          }
          @case (fieldType.Boolean) {
            <mat-slide-toggle color="primary" class="boolean"
              [matTooltip]="fieldComp.description" matTooltipPosition="right"
              [formControlName]="fieldComp.key">{{ fieldComp.label }}
            </mat-slide-toggle>
          }
        }
      </div>
    </div>
  </div>
}

<!--  <div class="errorMessage" *ngIf="!isValid">{{question.label}} is required</div-->
